export default "__VITE_ASSET__B9d5j9ZA__"